module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "wqb-box"
  }, [_c('div', {
    staticClass: "wqb-asset-card"
  }, [_c('div', {
    staticClass: "wqb-asset-header"
  }, [_c('span', {
    staticClass: "wqb-asset-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zongzichanguzhi')))]), _vm._v(" "), _c('span', {
    staticClass: "wqb-asset-link"
  }, [_vm._v(_vm._s(_vm.$t('all.liushuijilu')))])]), _vm._v(" "), _c('div', {
    staticClass: "wqb-asset-amount"
  }, [_vm._v(_vm._s(_vm.data.sumAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "wqb-currency-list"
  }, _vm._l((_vm.data.walletList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wqb-currency-item",
      on: {
        "click": function($event) {
          return _vm.handleGoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "wqb-currency-icon"
    }, [_c('img', {
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wqb-currency-info"
    }, [_c('span', {
      staticClass: "wqb-currency-name"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "wqb-currency-detail"
    }, [_vm._v(_vm._s(_vm.$t('all.keyong')) + " " + _vm._s(item.sumAvailableAmount) + " " + _vm._s(_vm.$t('all.dongjie')) + " " + _vm._s(item.sumFreezeAmount))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wqb-currency-arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d640ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wodeqianbao/wodeqianbao.vue
// module id = 951
// module chunks = 1